import { render, staticRenderFns } from "./creditform.vue?vue&type=template&id=0365cc3c"
import script from "./creditform.vue?vue&type=script&lang=js"
export * from "./creditform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports